import { PublicKey } from '@solana/web3.js';

const GAME_STATE_SIZE = 171;
const ANCHOR_DISCRIMINATOR_SIZE = 8;

const GAME_STATE_STATUS_LABELS = {
  0: 'pending',
  1: 'active',
  2: 'final_countdown',
  3: 'redeeming',
  4: 'closed',
};

function createDataView(bytes, offset, length) {
  return new DataView(bytes.buffer, bytes.byteOffset + offset, length);
}

function readPubkey(bytes, offset) {
  return new PublicKey(bytes.slice(offset, offset + 32)).toBase58();
}

function readU64(bytes, offset) {
  return createDataView(bytes, offset, 8).getBigUint64(0, true).toString();
}

function readI64(bytes, offset) {
  return createDataView(bytes, offset, 8).getBigInt64(0, true).toString();
}

function readU8(bytes, offset) {
  return bytes[offset];
}

export function decodeGameState(data) {
  const bytes = data instanceof Uint8Array ? data : new Uint8Array(data);
  const offset = bytes.length >= GAME_STATE_SIZE + ANCHOR_DISCRIMINATOR_SIZE ? ANCHOR_DISCRIMINATOR_SIZE : 0;

  if (bytes.length < offset + GAME_STATE_SIZE) {
    throw new Error('Invalid gameState account size.');
  }

  let cursor = offset;

  const decoded = {
    game_id: readU64(bytes, cursor),
  };
  cursor += 8;

  decoded.status = readU8(bytes, cursor);
  decoded.status_label = GAME_STATE_STATUS_LABELS[decoded.status] || 'unknown';
  cursor += 1;

  decoded.mint = readPubkey(bytes, cursor);
  cursor += 32;

  decoded.reserve_vault = readPubkey(bytes, cursor);
  cursor += 32;

  decoded.start_ts = readI64(bytes, cursor);
  cursor += 8;

  decoded.end_ts = readI64(bytes, cursor);
  cursor += 8;

  decoded.boost = readU64(bytes, cursor);
  cursor += 8;

  decoded.current_supply = readU64(bytes, cursor);
  cursor += 8;

  decoded.total_dumped_lamports = readU64(bytes, cursor);
  cursor += 8;

  decoded.minimum_live_time_secs = readI64(bytes, cursor);
  cursor += 8;

  decoded.graduation_target_lamports = readU64(bytes, cursor);
  cursor += 8;

  decoded.countdown_end_ts = readI64(bytes, cursor);
  cursor += 8;

  decoded.final_reserve_snapshot_lamports = readU64(bytes, cursor);
  cursor += 8;

  decoded.final_supply_snapshot = readU64(bytes, cursor);
  cursor += 8;

  decoded.redeem_end_ts = readI64(bytes, cursor);
  cursor += 8;

  decoded.closed_ts = readI64(bytes, cursor);
  cursor += 8;

  decoded.decimals = readU8(bytes, cursor);
  cursor += 1;

  decoded.bump = readU8(bytes, cursor);

  return decoded;
}
